import FlipCountdown from '@rumess/react-flip-countdown';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

// eslint-disable-next-line arrow-body-style
export const CountDownTimer = () => {
  return (
    <Box mt={8}>
      <Box ml={30} mr={30}>
        <FlipCountdown
          sx={{ mt: 4 }}
          theme="dark"
          hideYear
          hideMonth
          dayTitle="Days"
          hourTitle="Hours"
          minuteTitle="Minutes"
          secondTitle="Seconds"
          size="medium"
          fontWeight="bold"
          endAtZero
          endAt={'2023-12-23 01:26:58'}
        />
      </Box>
      <Box mt={2} ml={30} mr={30}>
        <Button
          variant="contained"
          sx={{
            display: 'block',
            width: '100%',
            bgcolor: '#000000',
            boxShadow: 'none',
            ':hover': { bgcolor: '#000000' },
            p: '1rem 1rem',
          }}
        >
          <Typography>
            <Link to="/" underline="none">
              {' '}
              Go Back{' '}
            </Link>
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};
